import React, { useState } from 'react';
import CheckBoxList from "./Elements/CheckBox/CheckBoxList.js";
import LoaderList from "./Elements/Loader/LoaderList.js";
import ButtonList from './Elements/Buttons/ButtonList';
import RadioButtons from "./Elements/RadioButtons/RadioButtons.js";
import './uielements.scss';
import CardList from './Elements/Card/CardList.js';


const UIElements = () => {
    const [filter, setFilter] = useState('all');
    const [selectedComponent, setSelectedComponent] = useState(null);

    const categories = ['all', 'buttons', 'checkbox', 'loader', 'Radio Button', 'Cards'];

    const images = [
        { id: 1, name: 'buttons', component: <ButtonList />, title: 'Button' },
        { id: 2, name: 'checkbox', component: <CheckBoxList />, title: 'Checkbox' },
        { id: 3, name: 'loader', component: <LoaderList />, title: 'Loader' },
        { id: 4, name: 'Radio Button', component: <RadioButtons />, title: 'Radio Button' },
        { id: 5, name: 'Cards', component: <CardList />, title: 'Cards' },
    ];

    const handleFilterChange = (category) => {
        setFilter(category);
    };

    const handleComponentDisplay = (component) => {
        setSelectedComponent(component);
    };

    return (
        <div className="MainUIElements">
            {/* Filter Buttons */}
            <div className="subUIElements" id="filter-buttons">
                <div className="UIElements">
                    {categories.map((category) => (
                        <button
                            key={category}
                            className={`btn ${filter === category ? 'active' : ''}`}
                            onClick={() => handleFilterChange(category)}
                        >
                            {category.charAt(0).toUpperCase() + category.slice(1)}
                        </button>
                    ))}
                </div>

                {/* Filterable Items */}
                <div className="UIElements-content" id="filterable-cards">
                    {images
                        .filter((img) => filter === 'all' || img.name === filter)
                        .map(({ id, component, title }) => (
                            <div key={id} className="ListOfUIElements" data-name={title}>
                                <div className="UIElements-card-img-top">
                                    <h3>{title}</h3>
                                    {component}
                                </div>
                            </div>
                        ))}
                </div>
            </div>

            {/* Display selected component */}
            {selectedComponent && (
                <div className="selected-component">
                    <h3>Selected UI Element:</h3>
                    {selectedComponent}
                </div>
            )}
        </div>
    );
};

export default UIElements;
